/* eslint-disable perfectionist/sort-objects */

const mock = '/mock';

const Auth = {
  Login: '/login',
  SignUp: '/sign-up',
  ResetPassword: '/reset-password',
  ForgotPassword: '/forgot-password',
};

const Profile = {
  Home: '/profile',
};

const Mock = {
  Home: mock,
  Details: ':id',
  New: 'new',
  Edit: 'edit/:id',
};

/* eslint-enable perfectionist/sort-objects */

export const AppRoutes = {
  Auth,
  Mock,
  Profile,
  Home: '/',
  NotFound: '/not-found',
};
